/***
 * Created on 2023/7/11
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import {CHINA, getCurrentDomainRegion} from "./common";
import {getLocalUser} from "./user";

const SUPPORTED_LANGUAGES = [
    { value: "en", "name": "English", "en_name": "English"},
    { value: "zh_TW", "name": "繁體中文", "en_name": "Traditional Chinese"},
    { value: "zh", "name": "简体中文", "en_name": "Simplified Chinese"},
    { value: "cs", "name": "Czech", "en_name": "Czech"},
    { value: "da", "name": "Dansk", "en_name": "Danish"},
    { value: "de", "name": "Deutsch", "en_name": "German"},
    { value: "es", "name": "Español", "en_name": "Spanish"},
    { value: "fr", "name": "Français", "en_name": "French"},
    { value: "it", "name": "Italiano", "en_name": "Italian"},
    { value: "ja", "name": "日本語", "en_name": "Japanese"},
    { value: "ko", "name": "한국", "en_name": "Korean"},
    { value: "no", "name": "Norsk", "en_name": "Norwegian"},
    { value: "pl", "name": "Polski", "en_name": "Polish"},
    { value: "ru", "name": "Русский", "en_name": "Russian"},
    { value: "fi", "name": "Suomi", "en_name": "Finnish"},
    { value: "sv", "name": "Svenska", "en_name": "Swedish"},
    { value: "nl", "name": "Nederlands", "en_name": "Dutch"},
    { value: "tr", "name": "Turk dili", "en_name": "Turkish"},
    { value: "th", "name": "ไทย", "en_name": "Thai"},
    { value: "pt", "name": "Português", "en_name": "Portuguese"},
    { value: "hu", "name": "Magyar", "en_name": "Hungarian"},
    { value: "el", "name": "Ελληνικά", "en_name": "Greek"},
    { value: "ro", "name": "Român", "en_name": "Romanian"}
];

export function getLanguageName(key) {
    return SUPPORTED_LANGUAGES.find(lang => lang.value === key)?.name || "";
}

export const getLocalLanguage = () => {
    const lang = localStorage.getItem('currentLang');
    return lang;
}

export const setLocalLanguage = (lang) => {
    localStorage.setItem('currentLang', lang);
}

export const detectDefaultLanguage = () => {
    const backup_lang = getCurrentDomainRegion() === CHINA ? 'zh' : 'en';
    const browser_lang = navigator.language || navigator.userLanguage;
    const currentUser = getLocalUser();
    const user_lang = currentUser?.language || null;
    const current_lang = getLocalLanguage();
    const lang = current_lang || user_lang || browser_lang || backup_lang;
    if (lang.toLowerCase() === 'en-us') {
        return 'en';
    }
    if (['zh_tw', 'zh-tw'].includes(lang.toLowerCase())) {
        return 'zh_TW';
    }
    return Object.keys(SUPPORTED_LANGUAGES).includes(lang) ? lang : 'en';
}

export default SUPPORTED_LANGUAGES;